import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import header from "../../assets/images/registrationHeader.png";
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 0,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  toolbar: {
    // minHeight: 100,
    // alignItems: 'flex-start',
    // paddingTop: theme.spacing(1),
    // paddingBottom: theme.spacing(2),
    // backgroundImage: `url(${header})`,
    //     backgroundSize: 'cover',
    //     alignItems: 'center',
    //     backgroundPositionY: '-150px',
    //     backgroundRepeat: 'no-repeat',
    //     backgroundSize: 'auto',
    //     backgroundColor: "#fff"
    minHeight: 100,
    alignItems: 'center',
    paddingTop: '8px',
    paddingBottom: '16px',
    backgroundSize: 'auto',
    backgroundColor: '#fff',
    backgroundImage: `url(${header})`,
    backgroundRepeat: 'no-repeat',
    backgroundPositionY: '-200px',
    color: '#000',

  },
  title: {
    flexGrow: 1,
    alignSelf: 'flex-end',
  },
  appBar: {
    boxShadow: 'none',
    backgroundColor: 'transparent'
  },
  rightHeaderDiv: {
    float: 'right'
  }
}));

export default function Header({ name, location, className }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          {/* <Typography className={classes.title} variant="h5" noWrap>
            Material-UI
          </Typography> */}
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <div>
                <Typography className={classes.title} align="left" noWrap>
                  {name}
                </Typography>
                <Typography className={classes.title} align="left" noWrap>
                  {location}
                </Typography>
              </div>
            </Grid>

            <Grid item xs={6} justify="flex-end"
              alignItems="center">
              <div className={classes.rightHeaderDiv}>
                <Typography className={classes.title} align="left" noWrap>
                  Assessment
          </Typography>
                <Typography className={classes.title} align="left" noWrap>
                  {location}
                </Typography>
                <Typography className={classes.title} align="left" noWrap>
                  {className}
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </div>
  );
}
